import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import MaterialTable from "material-table";
import {
  MuiThemeProvider,
  createMuiTheme,
  makeStyles,
  createStyles,
} from "@material-ui/core/styles";
import { ExportCsv, ExportPdf } from "@material-table/exporters";
import { deviceStatusCode, deviceModeCode, deviceErrorEventCode, deviceErrorEventCodeOrder } from "../../constants/constants";
import "../../styles/reports.scss";
import { exportMaterialTableToExcel, exportMaterialTableToPDF, getDateString, timeConvertUtility, timeDurationToTime } from "../../utilities/utility";
import DeviceAddressService from "../../apis/device-address";
import DeviceDataService from "../../apis/device-data"
import LampDataService from "../../apis/lamps-data"
import { format } from "date-fns";
import { Pagination } from "@material-ui/lab";
import PoleDataService from "../../apis/pole-data";
import { flexRender, getCoreRowModel, getPaginationRowModel, useReactTable } from "@tanstack/react-table";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Menu, MenuItem, Paper, TextField, Typography, useMediaQuery, useTheme } from "@material-ui/core";
import SearchIcon from '@mui/icons-material/Search';
import DownloadIcon from '@mui/icons-material/Download';
import { FiDownload } from "react-icons/fi";
import jsPDF from "jspdf";
import * as XLSX from 'xlsx';
import autoTable from "jspdf-autotable";
import FileSaver from "file-saver";
import CloseIcon from "@material-ui/icons/Close";
import { checkUserAccess, db, getUserName } from "../../apis/auth";
import { collection, getDocs, query, where } from "firebase/firestore";
import { getSLCByid } from "../../query/device.query";
import IconButton from "@material-ui/core/IconButton";
import SlcMap from "./LampMap";
import HistoryIcon from '@mui/icons-material/History';
import EditIcon from '@mui/icons-material/Edit';
import ToggleOffTwoToneIcon from '@mui/icons-material/ToggleOffTwoTone';
import ToggleOnTwoToneIcon from '@mui/icons-material/ToggleOnTwoTone';
import { fetchDimSchedule, getDimSchedule, getDimScheduleByILMID, getDimScheduleHistoryAPICall, getScheduleHistoryAPICall, updateDimSchedule, updateDimScheduleFromPopup, updateIndividualDimScheduleFlag } from "../../query/dim-schedule.query";
import { DimSchedule } from "../Settings/dim-schedule.screen";
import { NotificationManager } from "react-notifications";
import { addDimSchHisWhenEnableStateChange, createDimScheduleHistory } from "../../query/dim-schedule-history.query";
import { MuiPickersUtilsProvider, TimePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';

const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
      margin: theme.spacing(1),
    },
    table: {
      minWidth: 650,
    },
    root: {
      width: "100%",
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      marginRight: 20,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(2),
      top: theme.spacing(2),
      color: theme.palette.grey[500],
    },
    tab: {
      '& .MuiBox-root': {
        padding: '0px',
      },
    },
  })
);

const LampLiveFeed = (props) => {
  const classes = useStyles();
  const [opReportData, setOpReportData] = useState([]);
  const [opTotalReportData, setTotalOpReportData] = useState([]);

  // ─── FIX: page is now controlled by props.page from the parent ───────────
  // The parent (LiveMeterFeed) owns the canonical page number and passes it
  // down so that pagination buttons in LampLiveFeed stay in sync with the
  // parent's LampDataService.getInstance().getPageIndex().
  const [page, setPage] = useState(props.page || 1);
  // ─────────────────────────────────────────────────────────────────────────

  const [pageSize, setPageSize] = useState(LampDataService.getInstance().getPageSize());
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [ILMDialog, setILMDialog] = useState(null);
  const [connectedSlc, setConnectedSlc] = useState("N/A");
  const [gatewaySlc, setGatewaySlc] = useState("N/A");
  
  const getLatLng = (rowData) => {
    let degreeSymbol = "\u00B0";
    let result = "";
    let latitude = 0;
    let longitude = 0;
    let pole = null;
    if (rowData?.pid != undefined && rowData?.pid != null) {
      pole = PoleDataService.getInstance().getPole(rowData?.pid);
    }

    if (pole != null && pole?.loc != undefined && pole?.loc != null) {
      const {
        loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
      } = pole;
      latitude = latitudeVal;
      longitude = longitudeVal;
    } else if (rowData?.lloc != undefined) {
      const {
        lloc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
      } = rowData;
      latitude = latitudeVal;
      longitude = longitudeVal;
    } else {
      const {
        loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
      } = rowData;
      latitude = latitudeVal;
      longitude = longitudeVal;
    }

    if ((latitude === undefined | "") || (longitude === undefined | "")) {
      return "N/A"
    }
    if (latitude > 0) {
      result = `${latitude.toFixed(4)}${degreeSymbol}N`;
    } else {
      result = `${latitude.toFixed(4)}${degreeSymbol}S`;
    }
    if (longitude > 0) {
      result = `[${result}, ${longitude.toFixed(4)}${degreeSymbol}E]`;
    } else {
      result = `[${result}, ${longitude.toFixed(4)}${degreeSymbol}W]`;
    }
    return result;
  }
  
  const [confirmDialog, setConfirmDialog] = useState(false);

  const [historyDialog, setHistoryDialog] = useState(null);
  const [dimScheduleHistoryOpen, setDimScheduleHistoryOpen] = useState(false);
  const [dimScheduleHistoryData, setDimScheduleHistoryData] = useState([]);
  const [dimSchedule, setDimSchedule] = useState({});
  const [dimSchTableData, setDimSchTableData] = useState({});
  const [enableStatus, setEnableStatus] = useState(false);
  const [dimScheduleDialog, setDimScheduleDialog] = useState({ view: '', start: new Date(), end: new Date() });
  const [onUpdateDimSchedule, setOnUpdateDimSchedule] = useState(false);

  // ─── FIX: totalRows comes from props.totalRecords (not props.page) ────────
  // Previously: setTotalRows(props.page) — props.page was being (mis)used to
  // carry totalRecords, making pageCount always 1 and disabling all buttons.
  // Now the parent passes a dedicated `totalRecords` prop.
  const [totalRows, setTotalRows] = useState(props.totalRecords || 0);
  // ─────────────────────────────────────────────────────────────────────────

  /// Dim Schedule CRED Operations
  const OnClickAddDimSchedule = async () => {
    if (dimSchedule.sch_list === undefined | null) {
      dimSchedule["sch_list"] = [];
    }
    if (dimSchedule.sch_list?.length < 5) {
      setDimScheduleDialog({ view: 'add', start: new Date(), end: new Date(), dp: 0 });
    } else {
      NotificationManager.error("Maximum dim schedile added.", "", 3000);
    }
  }

  const OnChangeDimPercentage = (e) => {
    const { target: { value = "" } = {} } = e;
    setDimScheduleDialog((prevState) => ({
      ...prevState,
      dp: value
    }));
  }

  const OnClickEditDimSchedule = async (rowData) => {
    const { off_time, on_time, dp } = rowData;
    const currentDate = new Date();
    const startTimeDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate(),
      on_time.hrs,
      on_time.mins
    );
    const endTimeDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate(),
      off_time.hrs,
      off_time.mins
    );
    setDimScheduleDialog({ view: 'edit', data: rowData, start: startTimeDate, end: endTimeDate, dp: dp });
  }

  const OnClickDeleteDimSchedule = async (rowData) => {
    let index = rowData["tableData"]["id"];
    let { sch_list, ver = 0 } = dimSchedule;
    sch_list.splice(index, 1);
    setDimSchedule((prevState) => ({
      ...prevState,
      sch_list: sch_list,
      ver: ver + 1,
    }));
    setOnUpdateDimSchedule(true);
  }

  const OnClickSaveDimSchedule = async (enableStatusVal) => {
    const _dimSchedule = JSON.parse(JSON.stringify(dimSchedule));
    let { sch_list, ver = 0 } = _dimSchedule;
    for (let i = 0; i < sch_list?.length; i++) {
      delete sch_list[i]["tableData"];
    }
    let user = localStorage.getItem("userEmail");
    await updateDimScheduleFromPopup({
      sch_list: sch_list,
      ver: ver + 1,
      name: ILMDialog.ilm_id,
      user,
      enabled: enableStatusVal,
    }).then(() => {
      console.log("Added Successfully");
      NotificationManager.success("Dim Schedule saved successfully", "", 3000);
      setHistoryDialog(null)
    }).catch((e) => {
      NotificationManager.error("Failed to save Dim Schedule", "", 3000);
      return;
    });

    await createDimScheduleHistory({
      sch_list: sch_list,
      ver: ver + 1,
      name: ILMDialog.ilm_id,
      user,
      ch_dt: new Date(),
      enabled: enableStatusVal,
    }).then(() => {
      setDimSchTableData((prevState) => ({
        ...prevState,
        sch_list: sch_list
      }));
      console.log("History Created Successfully");
    }).catch((e) => {
      console.log(`History Create Failed = ${e}`);
    });

    setDimSchedule((prevState) => ({
      ...prevState,
      sch_list: dimSchedule.sch_list,
      ver: ver + 1,
    }));
    setOnUpdateDimSchedule(false);
    setConfirmDialog(false)
  }

  const OnClickUpdateDimSchedule = async () => {
    let { sch_list, ver = 0 } = dimSchedule;
    let { dp } = dimScheduleDialog;
    if (parseInt(dp) === NaN) {
      NotificationManager.error("Please enter valid dim percentage", "", 3000);
      return;
    }
    if (dimScheduleDialog.view === 'add') {
      sch_list.push({
        on_time: {
          hrs: dimScheduleDialog.start.getHours(),
          mins: dimScheduleDialog.start.getMinutes()
        },
        off_time: {
          hrs: dimScheduleDialog.end.getHours(),
          mins: dimScheduleDialog.end.getMinutes()
        },
        "dp": parseInt(dp),
      });
    } else {
      let index = dimScheduleDialog.data["tableData"]["id"];
      sch_list[index] = {
        on_time: {
          hrs: dimScheduleDialog.start.getHours(),
          mins: dimScheduleDialog.start.getMinutes()
        },
        off_time: {
          hrs: dimScheduleDialog.end.getHours(),
          mins: dimScheduleDialog.end.getMinutes()
        },
        "dp": parseInt(dp),
      }
    }
    setDimSchedule((prevState) => ({
      ...prevState,
      sch_list: sch_list,
    }));
    setOnUpdateDimSchedule(true);
    setDimScheduleDialog({ view: '', start: new Date(), end: new Date() });
  }

  const OnClickCancelDimSchedule = async () => {
    setDimScheduleDialog({ view: '' });
  }

  const handleSelectedDate = (date, type) => {
    if (type === "dim-start") {
      setDimScheduleDialog((prevState) => ({
        ...prevState,
        start: date
      }));
    } else if (type === "dim-end") {
      setDimScheduleDialog((prevState) => ({
        ...prevState,
        end: date
      }));
    }
  };
  
  const getData = async () => {
    await fetchDimSchedule(ILMDialog?.ilm_id)
      .then((records) => {
        setDimSchedule(JSON.parse(JSON.stringify(records)));
        setDimSchTableData(JSON.parse(JSON.stringify(records)));
        setEnableStatus(records.enabled || false);
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  }
  
  useEffect(async () => {
    await getData()
  }, [ILMDialog]);
  
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  
  // Update local state when props.devices changes and reset search/page
  useEffect(() => {
    setOpReportData(props.devices || []);
    setTotalOpReportData(props.devicePaged || []);
    setFilteredData(props.devices || []);
    setSearchQuery('');
    // ─── FIX: sync local page with the parent's authoritative page prop ───
    setPage(props.page || 1);
    // ─────────────────────────────────────────────────────────────────────
  }, [props.devices, props.devicePaged]);

  // ─── FIX: sync totalRows when the parent sends a new totalRecords ─────────
  useEffect(() => {
    setTotalRows(props.totalRecords || 0);
  }, [props.totalRecords]);
  // ─────────────────────────────────────────────────────────────────────────

  // ─── FIX: sync local page when parent page prop changes ──────────────────
  // e.g. after filter apply resets to page 1
  useEffect(() => {
    setPage(props.page || 1);
  }, [props.page]);
  // ─────────────────────────────────────────────────────────────────────────

  // Reset UI state when ILM UID filter changes
  useEffect(() => {
    setSearchQuery('');
    setPage(1);
  }, [props.ilmUid]);

  // Handle search
  useEffect(() => {
    if (searchQuery) {
      const filtered = opTotalReportData.filter((row) =>
        String(row.ilm_id ?? '').toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredData(filtered);
      setPage(1);
    } else {
      setFilteredData(opReportData);
    }
  }, [searchQuery, opTotalReportData, opReportData]);

  // Get paginated data slice
  const currentPageData = searchQuery
    ? filteredData.slice((page - 1) * pageSize, page * pageSize)
    : filteredData;

  // ─── FIX: pageCount now uses totalRows which is set from props.totalRecords
  const pageCount = searchQuery
    ? Math.ceil(filteredData.length / pageSize)
    : Math.ceil(totalRows / pageSize);
  // ─────────────────────────────────────────────────────────────────────────

  const columns = [
    {
      id: 'uid',
      header: 'UID',
      accessorFn: row => row?.ilm_id ?? '',
      Cell: ({ value }) => value || '',
      exportTransformer: (row) => row.original?.ilm_id || ''
    },    
    {
      id: 'slc no',
      header: 'CONNECT SLC',
      accessorKey: 'slc_id',
      Cell: ({ value }) => value || '',
      exportTransformer: (row) => row.original.slc_id || ''
    },
    {
      id: 'zone',
      header: 'ZONE',
      accessorKey: 'zn',
      Cell: ({ value }) => value || '',
      exportTransformer: (row) => row.original.zn || ''
    },
    {
      id: 'ward',
      header: 'WARD',
      cell: (row) => {
        return row.row.original.wd || ''
      },
      exportTransformer: (row) => row.original.wd || ''
    },
    {
      id: 'location',
      header: 'LOCATION',
      cell: (row) => {
        const pole = PoleDataService.getInstance().getPole(row.row.original.pid);
        return pole?.addr || 'N/A';
      },
      exportTransformer: (row) => {
        const pole = PoleDataService.getInstance().getPole(row.original.pid);
        return pole?.addr || 'N/A';
      }
    },
    {
      id: 'Gateway SLC',
      header: 'GATEWAY SLC',
      cell: (row) => {
        return row.row.original?.gw_id || 'N/A';
      },
      exportTransformer: (row) => {
        return row.original?.gw_id || 'N/A';
      }
    },
    {
      id: 'status',
      header: 'STATUS',
      cell: (row) => {
        var statusCode = row.row.original.dev_st || 0;
        var dp = row.row.original.dp || 0;
        if (statusCode === 1 && dp > 0) {
          return <div style={{ color: statusCode === 1 ? '#1EAC24' : '#EC3434' }}>{deviceStatusCode[3]}</div>
        } else {
          return <div style={{ color: statusCode === 1 ? '#1EAC24' : '#EC3434' }}>{deviceStatusCode[statusCode]}</div>
        }
      },
      exportTransformer: (row) => {
        var statusCode = row.original.dev_st || 0;
        var dp = row.original.dp || 0;
        if (statusCode === 1 && dp > 0) {
          return deviceStatusCode[3]
        }
        else {
          return deviceStatusCode[statusCode]
        }
      },
    },
    {
      id: 'current',
      header: 'CURRENT',
      cell: (row) => {
        var ma = row.row.original.ma || 0;
        if (ma > 0) {
          let amps = ma / 1000;
          return Math.round(amps * 100) / 100;
        }
        return 0;
      },
      exportTransformer: (row) => {
        var ma = row.original.ma || 0;
        if (ma > 0) {
          let amps = ma / 1000;
          return Math.round(amps * 100) / 100;
        }
        return 0;
      },
    },
    {
      id: 'wt',
      header: 'WATTS',
      accessorKey: 'wt',
      Cell: ({ value }) => value || '',
      exportTransformer: (row) => row.original.wt || ''
    },
    {
      id: 'dim %',
      header: 'DIM %',
      cell: (row) => {
        var dp = row.row.original.dp || 0;
        return dp;
      },
      exportTransformer: (row) => {
        var dp = row.original.dp || 0;
        return dp;
      },
    },
    {
      id: 'last_seen',
      header: 'LAST SEEN',
      cell: (row) => {
        let value = row.row.original.ls;
        if (value?.seconds != null && value?.nanoseconds != null) {
          const timestampInMillis = value?.seconds * 1000 + value?.nanoseconds / 1000000;
          const date = new Date(timestampInMillis);
          return format(date, "dd/MM/yyyy, hh:mm a");
        }
        return ""
      },
      exportTransformer: (row) => {
        let value = row.original.ls;
        if (value?.seconds != null && value?.nanoseconds != null) {
          const timestampInMillis = value?.seconds * 1000 + value?.nanoseconds / 1000000;
          const date = new Date(timestampInMillis);
          return format(date, "dd/MM/yyyy, hh:mm a");
        }
        return ""
      }
    },
    {
      id: 'burn hours',
      header: 'BURN HOURS',
      cell: (row) => {
        var rsecs = Number(row.row.original.rsecs || 0);
        if (rsecs !== 0) {
          const hours = Math.floor(rsecs / 3600);
          const minutes = Math.floor((rsecs % 3600) / 60);
          const formattedHours = hours.toString().padStart(2, '0');
          const formattedMinutes = minutes.toString().padStart(2, '0');
          return `${formattedHours}:${formattedMinutes}`;
        }
        return '00:00';
      },
      exportTransformer: (row) => {
        var rsecs = Number(row.original.rsecs || 0);
        if (rsecs !== 0) {
          const hours = Math.floor(rsecs / 3600);
          const minutes = Math.floor((rsecs % 3600) / 60);
          const formattedHours = hours.toString().padStart(2, '0');
          const formattedMinutes = minutes.toString().padStart(2, '0');
          return `${formattedHours}:${formattedMinutes}`;
        }
        return '00:00';
      },
    },
    {
      id: 'errors',
      header: 'ERRORS',
      cell: (row) => {
        let errors = row.row.original.errors;
        const result = errors?.map(item => (deviceErrorEventCode[item] || '')) || '';
        if (Array.isArray(result)) {
          return result.join(', ');
        }
        return result;
      },
      exportTransformer: (row) => {
        let errors = row.original.errors;
        const result = errors?.map(item => (deviceErrorEventCode[item] || '')) || '';
        if (Array.isArray(result)) {
          return result.join(', ');
        }
        return result;
      }
    },
  ];

  const column = [
    {
      title: "Start Time",
      render: ({ on_time: { hrs = 0, mins = 0 } = {} }) => {
        return timeDurationToTime({ hrs, mins });
      },
      exportTransformer: ({ on_time: { hrs = 0, mins = 0 } = {} }) => {
        return timeDurationToTime({ hrs, mins });
      },
    },
    {
      title: "End Time",
      render: ({ off_time }) => {
        return off_time ? timeDurationToTime(off_time) : 'N/A';
      },
      exportTransformer: ({ off_time: { hrs = 0, mins = 0 } = {} }) => {
        return timeDurationToTime({ hrs, mins });
      },
    },
    {
      title: "DIM %",
      render: ({ dp = 0 }) => {
        return dp + "%";
      },
      exportTransformer: ({ dp = 0 }) => {
        return dp + "%";
      },
    },
  ];

  const table = useReactTable({
    data: currentPageData,
    columns,
    pageCount,
    manualPagination: true,
    state: {
      pagination: {
        pageIndex: page - 1,
        pageSize,
      },
    },
    getCoreRowModel: getCoreRowModel(),
    onPaginationChange: (updater) => {
      const newPagination =
        typeof updater === 'function'
          ? updater({ pageIndex: page - 1, pageSize })
          : updater;
      const newPage = newPagination.pageIndex + 1;
      setPage(newPage);
      if (!searchQuery) {
        LampDataService.getInstance().setPageIndex(newPage);
        props.onUpdate();
      }
    },
  });

  const handleSearchChange = (event) => {
    table.firstPage();
    setSearchQuery(event.target.value);
  };

  const clearSearch = () => {
    setSearchQuery('');
  };

  const fullTable = useReactTable({
    data: opTotalReportData,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  const downloadFile = (table, format) => {
    onClose();
    const headers = table.getHeaderGroups()[0].headers.map(column => column.id.toLocaleUpperCase());
    const rows = table.getRowModel().rows.map(row => {
      return row.getVisibleCells().map(cell => {
        const column = table.getColumn(cell.column.id);
        const transformedValue = column.columnDef.exportTransformer
          ? column.columnDef.exportTransformer(row)
          : String(cell.getValue());
        return transformedValue;
      });
    });

    if (format === 'excel') {
      const ws_data = [headers, ...rows];
      const ws = XLSX.utils.aoa_to_sheet(ws_data);
      const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      const dataBlob = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(dataBlob, `LampLiveFeed-${new Date().toLocaleDateString()}.xlsx`);
    }
    else if (format === 'pdf') {
      const doc = new jsPDF({
        orientation: 'l',
        unit: 'in',
        format: [8, 18],
      });
      autoTable(doc, {
        head: [headers],
        body: rows,
      });
      doc.save(`Live Meter Report-${getDateString()}.pdf`);
    }
    else {
      console.error('Unsupported format: ' + format);
    }
  };

  const hideIlmInformationDialog = () => {
    setEnableStatus(false);
    setDimSchTableData({});
    setDimSchedule({});
    setILMDialog(null);
    setConnectedSlc("N/A");
    setGatewaySlc("N/A");
  }
  
  const onClose = () => {
    setAnchor(null);
    setExportAction(null);
  }
 
  const [anchor, setAnchor] = React.useState(null);
  const [exportAction, setExportAction] = React.useState(null);

  const handleExport = async (event, data) => {
    setAnchor(event.currentTarget);
    setExportAction(data ?? false);
  }
  
  const scheduleDialogClose = async () => {
    if (onUpdateDimSchedule) {
      setConfirmDialog(true);
      return
    }
    setDimSchedule(JSON.parse(JSON.stringify(dimSchTableData)));
    getData()
    setHistoryDialog(false);
  }

  const getDimScheduleHistoryColumnList = () => {
    return [
      {
        title: "Name",
        field: "name",
      },
      {
        title: "Status",
        field: "enabledStatus",
      },
      {
        title: "Schedule",
        field: "scList",
      },
      {
        title: "Modified By",
        field: "lastModifiedBy",
      },
      {
        title: "Date",
        field: "lastModifiedDate",
      },
    ];
  };
  
  let editAction = checkUserAccess("schedule");

  return (
    <div>
      {/* ILM Information Table */}
      <div
        style={{
          margin: '20px 0',
          width: '100%',
          backgroundColor: '#fff',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
          borderRadius: '5px',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#fff',
            padding: '10px',
            borderBottom: '1px solid #ddd',
            justifyContent: 'flex-end',
            marginBottom: -20,
            paddingRight: '20px',
            borderRadius: '5px',
          }}
        >
          <div style={{ borderBottom: '1px solid #666666' }}>
            <SearchIcon
              style={{
                marginBottom: '-4px',
                fontSize: '18px',
                color: '#000000',
              }}
            />
            <input
              type="text"
              placeholder="Search "
              value={searchQuery}
              onChange={handleSearchChange}
              style={{
                padding: '8px',
                fontSize: '1em',
                borderRadius: '0',
                border: 'none',
                borderBottom: '2px solid #FFFFFF',
                width: '200px',
                marginRight: '10px',
                outline: 'none',
              }}
            />
            <CloseIcon
              style={{
                fontSize: '18px',
                color: searchQuery ? '#5e5e5e' : '#8c8c8c',
                cursor: searchQuery ? 'pointer' : 'default',
                marginRight: '10px',
                marginBottom: '-5px',
              }}
              onClick={searchQuery ? clearSearch : null}
            />
          </div>
          <FiDownload
            style={{
              fontSize: '20px',
              color: '#666666',
              marginLeft: '10px',
              cursor: 'pointer',
            }}
            onClick={(event) => handleExport(event, true)}
          />
        </div>
        
        <Menu
          id="long-menu"
          anchorEl={anchor}
          keepMounted
          open={exportAction}
          onClose={onClose}
        >
          <MenuItem key={"Export as Excel"} onClick={() => { downloadFile(fullTable, "excel") }}>{"Export as Excel"}</MenuItem>
          <MenuItem key={"Export as PDF"} onClick={() => { downloadFile(fullTable, "pdf") }}>{"Export as PDF"}</MenuItem>
        </Menu>
        
        <div
          style={{
            overflowX: 'auto',
            overflowY: 'hidden',
          }}
        >
          <table
            style={{
              margin: '20px 0px 0 0',
              width: '100%',
              borderCollapse: 'collapse',
            }}
          >
            <thead>
              {table.getHeaderGroups().map((headerGroup) => (
                <tr
                  key={headerGroup.id}
                  style={{
                    backgroundColor: '#0071CE',
                    color: '#FFF',
                    textAlign: 'center',
                    margin: 10,
                  }}
                >
                  {headerGroup.headers.map((column) => (
                    <th colSpan={column.colSpan} key={column.id} style={{ padding: '25px', fontSize: '0.9em' }}>
                      {flexRender(
                        column.column.columnDef.header,
                        column.getContext()
                      )}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody>
              {table.getRowModel().rows.length > 0 ? (
                table.getRowModel().rows.map((row) => (
                  <tr
                    onClick={async () => {
                      var slc = await getSLCByid(row.original?.slc_id).catch((e) => { });
                      if (slc != null) {
                        setConnectedSlc(slc.dev_id);
                        setGatewaySlc(slc.gw_id);
                      }
                      setILMDialog(row.original);
                    }}
                    key={row.id}
                    style={{ cursor: 'pointer' }}
                  >
                    {row.getVisibleCells().map((cell) => (
                      <td
                        style={{
                          padding: '20px',
                          border: '0px solid #ddd',
                          justifyContent: 'flex-start',
                        }}
                        key={cell.id}
                      >
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={table.getHeaderGroups()[0].headers.length}
                    style={{ textAlign: 'center', padding: '20px' }}
                  >
                    No records to display
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* ── ILM Pagination ── */}
        {/*
          ─── FIX: All pagination buttons now call props.onChangePage with the
              new page number, which triggers onChangeLampPage in the parent.
              The parent updates LampDataService.setPageIndex and calls
              UpdateLampTable, which fetches the new page from the backend and
              passes fresh data back via props.devices / props.totalRecords.
              Previously, these buttons were dead because pageCount was always
              1 (since totalRows was set from props.page = totalRecords, making
              Math.ceil(totalRecords / pageSize) the correct count but
              page was ALSO set to totalRecords, so page >= pageCount was
              immediately true and buttons were disabled).
        ─── */}
        <Button
          onClick={() => {
            if (!searchQuery) {
              props.onChangePage(null, 1);
            } else {
              setPage(1);
              table.setPageIndex(0);
            }
          }}
          disabled={page === 1}
        >
          <KeyboardDoubleArrowLeftIcon />
        </Button>

        <Button
          onClick={() => {
            if (page > 1) {
              const newPage = page - 1;
              if (!searchQuery) {
                props.onChangePage(null, newPage);
              } else {
                setPage(newPage);
                table.setPageIndex(newPage - 1);
              }
            }
          }}
          disabled={page === 1}
        >
          <KeyboardArrowLeftIcon />
        </Button>

        <span>
          Page {page} of {pageCount || 1}
        </span>

        <Button
          onClick={() => {
            if (page < pageCount) {
              const newPage = page + 1;
              if (!searchQuery) {
                props.onChangePage(null, newPage);
              } else {
                setPage(newPage);
                table.setPageIndex(newPage - 1);
              }
            }
          }}
          disabled={page >= pageCount}
        >
          <KeyboardArrowRightIcon />
        </Button>

        <Button
          onClick={() => {
            if (!searchQuery) {
              props.onChangePage(null, pageCount);
            } else {
              setPage(pageCount);
              table.setPageIndex(pageCount - 1);
            }
          }}
          disabled={page >= pageCount}
        >
          <KeyboardDoubleArrowRightIcon />
        </Button>

        <select
          style={{ padding: '8px', minWidth: '100px' }}
          value={table.getState().pagination.pageSize}
          onChange={e => {
            const newSize = Number(e.target.value);
            LampDataService.getInstance().setPageIndex(1);
            LampDataService.getInstance().setPageSize(newSize);
            setPageSize(newSize);
            table.setPageSize(newSize);
            table.setPageIndex(0);
            // ─── FIX: Notify parent to reload page 1 with new size ────────
            props.onChangePage(null, 1);
            // ─────────────────────────────────────────────────────────────
          }}
        >
          {[10, 20, 30, 40, 50].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              {pageSize}
            </option>
          ))}
        </select>
      </div>

      {/* ILM Information popup */}
      <Dialog className="history-dialog" open={ILMDialog != null} onClose={hideIlmInformationDialog} aria-labelledby="form-dialog-title" fullScreen={fullScreen} fullWidth maxWidth="lg"
        sx={{
          '& .MuiDialogContainer-root': {
            maxWidth: '80%',
            height: '90vh',
          },
        }}
      >
        <DialogTitle id="form-dialog-title">{ILMDialog?.uid}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} justifyContent="center">
            <Grid item xs={12} sm={12} md={12}>
              <Typography variant="h6" gutterBottom style={{ fontWeight: 'bold', marginBottom: '20px', color: '#333', paddingLeft: '20px' }}>
                ILM Information   
                <IconButton
                  aria-label="close"
                  className={classes.closeButton}
                  onClick={hideIlmInformationDialog}
                >
                  <CloseIcon />
                </IconButton>
              </Typography>
              <div style={{ marginBottom: '15px', padding: '20px' }}>
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <Typography variant="body2" className="typography-root">
                      <strong>ILM ID: </strong> <span className="typography-value">{ILMDialog?.ilm_id || 'N/A'}</span>
                    </Typography>
                    <Typography variant="body2" className="typography-root">
                      <strong>Connected SLC: </strong> <span className="typography-value">{connectedSlc}</span>
                    </Typography>
                    <Typography variant="body2" className="typography-root">
                      <strong>UID: </strong> <span className="typography-value">{ILMDialog?.dev_id || 'N/A'}</span>
                    </Typography>
                    <Typography variant="body2" className="typography-root">
                      <strong>Lamp Number: </strong> <span className="typography-value">{ILMDialog?.lnum || 'N/A'}</span>
                    </Typography>
                    <Typography variant="body2" className="typography-root">
                      <strong>Pole Number: </strong> <span className="typography-value">{ILMDialog?.pid ? PoleDataService.getInstance().getPole(ILMDialog?.pid)?.pnum : 'N/A'}</span>
                    </Typography>
                    <Typography variant="body2" className="typography-root">
                      <strong>Watts: </strong><span className="typography-value">{ILMDialog?.wt || 'N/A'}</span>
                    </Typography>
                    <Typography variant="body2" className="typography-root">
                      <strong>Watts before conversion: </strong> <span className="typography-value">{ILMDialog?.old_wt > 0 ? ILMDialog?.old_wt : 'N/A'}</span>
                    </Typography>
                    <Typography variant="body2" className="typography-root">
                      <strong>Gateway SLC: </strong> <span className="typography-value">{gatewaySlc}</span>
                    </Typography>
                    <Typography variant="body2" className="typography-root">
                      <strong>Ward: </strong> <span className="typography-value">{ILMDialog?.wd || 'N/A'}</span>
                    </Typography>
                    <Typography variant="body2" className="typography-root">
                      <strong>Zone: </strong> <span className="typography-value">{ILMDialog?.zn || 'N/A'}</span>
                    </Typography>
                    <Typography variant="body2" className="typography-root">
                      <strong>GPS Location: </strong> <span className="typography-value">{ILMDialog ? getLatLng(ILMDialog) : "N/A"}</span>
                    </Typography>
                    <Typography variant="body2" className="typography-root">
                      <strong>Location: </strong> <span className="typography-value">{ILMDialog?.pid ? PoleDataService.getInstance().getPole(ILMDialog?.pid)?.addr : 'N/A'}</span>
                    </Typography>
                    <Typography variant="body2" className="typography-root">
                      <strong>Last Changed: </strong> <span className="typography-value">{ILMDialog?.mdt ? new Date((ILMDialog?.mdt?.seconds * 1000) + ILMDialog?.mdt?.nanoseconds / 1000000).toLocaleString() : "N/A"}</span>
                    </Typography>
                    <Typography variant="body2" className="typography-root">
                      <strong>Serial Number: </strong> <span className="typography-value">{ILMDialog?.sno || 'N/A'}</span>
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography style={{ marginLeft: "15px" }} variant="body2" className="typography-root">
                      <strong>Status: </strong> <span className="typography-value">{(ILMDialog?.dev_st === 1 && ILMDialog?.dp > 0) ? deviceStatusCode[3] : deviceStatusCode[2]}</span>
                    </Typography>
                    <Typography variant="body2" className="typography-root" style={{ marginLeft: "15px", display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <strong>Schedule Enabled : ({enableStatus ? "Individual" : "Global"})</strong>
                      <div style={{ display: 'flex', alignItems: 'center', marginRight: '100px', height: '30px', width: '30px' }}>
                        {!enableStatus && (
                          <ToggleOffTwoToneIcon
                            onClick={async () => {
                              setEnableStatus(true);
                              await getDimScheduleByILMID(ILMDialog?.ilm_id).then(async (records) => {
                                if (records != null) {
                                  await updateIndividualDimScheduleFlag({
                                    name: ILMDialog.ilm_id,
                                    enabled: true,
                                  });
                                  setDimSchedule(JSON.parse(JSON.stringify(records)));
                                  setDimSchTableData(JSON.parse(JSON.stringify(records)));
                                } else {
                                  setDimSchedule([]);
                                  setDimSchTableData([]);
                                  setHistoryDialog(true);
                                }
                              }).catch((e) => {
                                NotificationManager.error("Failed to fetch record", "", 3000);
                              });
                            }}
                            style={{ color: "red", width: '30px', height: '30px' }}
                            titleAccess="Off"
                          />
                        )}
                        {enableStatus && (
                          <ToggleOnTwoToneIcon
                            onClick={async () => {
                              setEnableStatus(false);
                              await getDimScheduleByILMID("curr_sch").then(async (records) => {
                                setDimSchedule(JSON.parse(JSON.stringify(records)));
                                setDimSchTableData(JSON.parse(JSON.stringify(records)));
                                await updateIndividualDimScheduleFlag({
                                  name: ILMDialog.ilm_id,
                                  enabled: false,
                                });
                              }).catch((e) => {
                                NotificationManager.error("Failed to fetch record", "", 3000);
                              });
                            }}
                            style={{ color: "green", width: '30px', height: '30px' }}
                            titleAccess="On"
                          />
                        )}
                      </div>
                    </Typography>
                    {enableStatus ? (
                      <Typography variant="body2" className="typography-root" style={{ paddingLeft: '10px', display: 'flex', alignItems: 'flex-end', justifyContent: 'end' }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginRight: '100px', height: '30px', width: '30px' }}>
                          {editAction && <EditIcon onClick={() => setHistoryDialog(true)} titleAccess="Edit" />}
                          {dimSchTableData?.sch_list?.length > 0 && (
                            <HistoryIcon
                              onClick={async () => {
                                await getDimScheduleHistoryAPICall(ILMDialog?.ilm_id || "").then((formattedHistory) => {
                                  setDimScheduleHistoryData(formattedHistory);
                                  setDimScheduleHistoryOpen(true);
                                }).catch((e) => {
                                  NotificationManager.error(e, "", 3000);
                                });
                              }}
                              style={{ marginLeft: '15px' }}
                              titleAccess="History"
                            />
                          )}
                        </div>
                      </Typography>
                    ) : (
                      <Typography variant="body2" className="typography-root" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginLeft: '15px' }}></Typography>
                    )}
                    {dimSchTableData?.sch_list?.length > 0 && (
                      <div>
                        <table style={{ width: "95%", borderCollapse: "collapse", marginLeft: '15px' }}>
                          <thead>
                            <tr>
                              {column.map((column, index) => (
                                <th key={index} style={{ padding: "8px", textAlign: "left", borderBottom: "2px solid #ddd" }}>
                                  {column.title}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {dimSchTableData?.sch_list?.map((schedule, index) => (
                              <tr key={index}>
                                {column.map((column, colIndex) => (
                                  <td key={colIndex} style={{ padding: "6px", borderBottom: "1px solid #ddd" }}>
                                    {column.render(schedule)}
                                  </td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                    {ILMDialog ? <SlcMap data={ILMDialog} /> : null}
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      {/* Dim Schedule display Dialog */}
      <Dialog className="history-dialog" open={historyDialog} onClose={() => { scheduleDialogClose() }} aria-labelledby="form-dialog-title" fullWidth maxWidth={'md'}>
        <DialogContent>
          <DimSchedule
            dimSchedule={dimSchedule}
            enableStatus={enableStatus}
            isUpdated={null}
            OnClickAddDimSchedule={OnClickAddDimSchedule}
            OnClickEditDimSchedule={OnClickEditDimSchedule}
            OnClickDeleteDimSchedule={OnClickDeleteDimSchedule}
            OnClickSaveDimSchedule={OnClickSaveDimSchedule}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            if (onUpdateDimSchedule) {
              OnClickSaveDimSchedule(enableStatus);
            } else {
              NotificationManager.error("No changes to save Dim Schedule", "", 3000);
            }
          }} color="primary">
            SAVE
          </Button>
          <Button onClick={() => { scheduleDialogClose() }} color="primary">
            CLOSE
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add & Edit Dim Schedule Dialog */}
      <Dialog
        className="change-schedule-dialog"
        onClose={OnClickCancelDimSchedule}
        aria-labelledby="editTime-dialog-title"
        open={dimScheduleDialog.view === '' ? false : true}
        fullWidth
      >
        <DialogTitle id="editTime-dialog-title" onClose={OnClickCancelDimSchedule}>
          {dimScheduleDialog.view === 'add' ? "Add" : "Edit"} Dim Schedule
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={OnClickCancelDimSchedule}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div className="change-schedule-wrapper">
            <div style={{ marginRight: "10%" }}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <TimePicker
                  autoOk
                  label="Start Time"
                  value={dimScheduleDialog.start}
                  onChange={(date) => handleSelectedDate(date, "dim-start")}
                />
              </MuiPickersUtilsProvider>
            </div>
            <div>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <TimePicker
                  autoOk
                  label="End Time"
                  value={dimScheduleDialog.end}
                  onChange={(date) => handleSelectedDate(date, "dim-end")}
                />
              </MuiPickersUtilsProvider>
            </div>
            <div style={{ marginLeft: "10%" }}>
              <TextField
                required
                id="standard-required"
                label="Dim Percentage"
                defaultValue={dimScheduleDialog.dp}
                variant="standard"
                onChange={OnChangeDimPercentage}
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button className="save-btn" onClick={OnClickUpdateDimSchedule} disabled={false}>Save</Button>
          <Button className="save-btn" onClick={OnClickCancelDimSchedule}>Cancel</Button>
        </DialogActions>
      </Dialog>

      {/* Display Dim Schedule History Dialog */}
      <Dialog className="history-dialog" sx={{
        '& .MuiDialogContainer-root': {
          maxWidth: '80%',
          height: '90vh',
        },
      }} open={dimScheduleHistoryOpen} onClose={() => { setDimScheduleHistoryOpen(false); setDimScheduleHistoryData([]) }} aria-labelledby="form-dialog-title" fullWidth maxWidth="lg">
        <DialogTitle id="form-dialog-title">Dim Schedule History</DialogTitle>
        <DialogContent>
          <MaterialTable
            style={{ width: "100%" }}
            className={classes.table}
            title={""}
            columns={getDimScheduleHistoryColumnList()}
            data={dimScheduleHistoryData}
            options={{
              exportButton: false,
              search: false,
              selection: false,
              sorting: true,
              pageSize: 5,
              headerStyle: {
                backgroundColor: "#0071CE",
                color: "#FFF",
                fontSize: "0.9em",
                textAlign: "center",
              },
              actionsColumnIndex: -1,
              emptyRowsWhenPaging: false,
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setDimScheduleHistoryOpen(false); setDimScheduleHistoryData([]) }} color="primary">CLOSE</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        className="change-schedule-dialog"
        onClose={() => {
          setConfirmDialog(false);
          setDimSchedule(JSON.parse(JSON.stringify(dimSchTableData)));
          getData();
          setHistoryDialog(false);
        }}
        aria-labelledby="edit-schedule-dialog-title"
        open={confirmDialog}
        fullWidth
      >
        <DialogTitle id="edit-schedule-dialog-title" onClose={() => {
          setConfirmDialog(false);
          setDimSchedule(JSON.parse(JSON.stringify(dimSchTableData)));
          getData();
          setHistoryDialog(false);
        }}>
          Confirm Schedule Update
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={() => {
              setConfirmDialog(false);
              setDimSchedule(JSON.parse(JSON.stringify(dimSchTableData)));
              getData();
              setHistoryDialog(false);
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1">Do you want to save the changes?</Typography>
        </DialogContent>
        <DialogActions>
          <Button className="save-btn" onClick={() => { OnClickSaveDimSchedule(enableStatus); }} color="primary">Save</Button>
          <Button className="cancel-btn" onClick={() => {
            setConfirmDialog(false);
            setDimSchedule(JSON.parse(JSON.stringify(dimSchTableData)));
            getData();
            setHistoryDialog(false);
          }} color="secondary">Cancel</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default LampLiveFeed;